import { render, staticRenderFns } from "./AdminSwimmingCompetition2.vue?vue&type=template&id=03730b48&"
import script from "./AdminSwimmingCompetition2.vue?vue&type=script&lang=js&"
export * from "./AdminSwimmingCompetition2.vue?vue&type=script&lang=js&"
import style0 from "./AdminSwimmingCompetition2.vue?vue&type=style&index=0&id=03730b48&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports